import React from 'react';
import { connect } from 'react-redux';
import { Pagination } from '@material-ui/lab';
import { BrowserView, MobileView } from 'react-device-detect';
import './ArticleCategory.scss';
import Published from '../Articles/Content/containers/Published';
import CategoriesList from '../Articles/Content/containers/CategoriesList';
import CardPosts from '../Articles/Content/containers/CardPosts/';
import ListPost from '../Articles/Content/containers/ListPost';
import MainTitle from '../Articles/Content/containers/MainTitle';
import Subtitle from '../Articles/Content/containers/Subtitle';
import BreadcrumbsA from '../Articles/Content/containers/Breadcrumbs/BreadcrumbsA';
import {
  getRecentArticles,
  getMostReadArticles,
} from '../../configs/environments/firebase/firebaseApp';
import { getArticlesByPage } from '../../store/actions/ArticlesActions';
import { withRouter } from 'react-router-dom';

class ArticleCategory extends React.Component {
  state = {
    posts: [],
    category: '',
    recentArticles: [],
    mostRead: [],
  };

  componentDidMount() {
    const category = this.props.match.params.category;
    this.fetchData(category);

    const params = category === 'Todas' ? {
      page: 1,
      limit: 8,
    } : {
      page: 1,
      limit: 8,
      category: category,
    };
    this.props.getArticlesByPage(params);

    getRecentArticles().then((article) => {
      this.setState({ recentArticles: article.data });
    });

    getMostReadArticles().then((article) => {
      this.setState({ mostRead: article.data });
    });
  }

  fetchData = (category) => {
    this.setState({ category: category });
  };

  handleChangePage = async (event, value) => {
    window.scrollTo(0,0)
    try {
      const params = this.state.category &&  this.state.category === 'Todas' ? {
        page: value,
        limit: 8,
      } : {
        page: value,
        limit: 8,
        category: this.state.category,
      };
      await this.props.getArticlesByPage(params);
    } catch (error) {
      throw error;
    }
  };

  render() {

    let showArticles = this.props.articles.data.map((post, index) => {
      return (
        <Published
          key={index}
          article = {post}
        />
      );
    });

    return (
      <>
        <BrowserView viewClassName="browser-custom-class">
          <div className="article-category-content">
            <div className="article-category-content-wrapper">
              <BreadcrumbsA postCategory={this.state.category} />
              <div className="category-title">
                <MainTitle
                  text={this.state.category &&  this.state.category === 'Todas' ? 'Todas las categorías' : `Artículos de ${this.state.category}`}
                ></MainTitle>
              </div>
              <div className="article-category-content-section">
                <div className="article-category-content-section-left">
                  <div className="category-list">{showArticles}</div>
                  {this.props.articles.totalPages &&
                  (this.props.articles.totalPages <= 1 ||
                    this.props.articles.totalPages === 0) ? null : this.props
                      .articles.totalPages === 0 ? null : (
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <Pagination
                        color="primary"
                        count={
                          this.props.articles && this.props.articles.totalPages
                        }
                        page={
                          this.props.articles && this.props.articles.actualpage
                        }
                        onChange={this.handleChangePage}
                      />
                    </div>
                  )}
                </div>

                <div className="article-category-content-section-right">
                  <div className="recents-list">
                    <CardPosts title="Posts Recientes" height="list">
                      {this.state.recentArticles.map((article, index) => (
                        <ListPost
                          key={index}
                          image="/img/articles/recent.svg"
                          text={article.title}
                          link={`/articulos/${article.categories[0]}/${article.id}`}
                        />
                      ))}
                    </CardPosts>
                  </div>
                  <div className="categories-list">
                    <CategoriesList />
                  </div>
                  <div className="read-list">
                    <CardPosts title="Artículos más leídos" height="list">
                      {this.state.mostRead.map((article, index) => (
                        <ListPost
                          key={index}
                          image="/img/articles/recent.svg"
                          text={article.title}
                          link={`/articulos/${article.categories[0]}/${article.id}`}
                        />
                      ))}
                    </CardPosts>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </BrowserView>

        <MobileView viewClassName="mobile-custom-class">
          <div className="article-category-content">
            <div className="article-category-content-wrapper">
              <div className="article-category-content-section">
                <BreadcrumbsA
                  postCategory={this.state.category}
                />
                <div className="category-title">
                  <Subtitle text={this.state.category} margin="featured"></Subtitle>
                </div>
                <div className="category-list">{showArticles}</div>
                {this.props.articles.totalPages &&
                  (this.props.articles.totalPages <= 1 ||
                    this.props.articles.totalPages === 0) ? null : this.props
                      .articles.totalPages === 0 ? null : (
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <Pagination
                        color="primary"
                        count={
                          this.props.articles && this.props.articles.totalPages
                        }
                        page={
                          this.props.articles && this.props.articles.actualpage
                        }
                        onChange={this.handleChangePage}
                      />
                    </div>
                  )}

                <div className="recents-list">
                  <CardPosts title="Posts Recientes" height="list">
                    {this.state.recentArticles.map((article, index) => (
                      <ListPost
                        key={index}
                        image="/img/articles/recent.svg"
                        text={article.title}
                        link={`/articulos/${article.categories[0]}/${article.id}`}
                      />
                    ))}
                  </CardPosts>
                </div>

                <div className="categories-list">
                  <CategoriesList />
                </div>
                <div className="read-list">
                  <CardPosts title="Artículos más leídos" height="list">
                    {this.state.mostRead.map((article, index) => (
                      <ListPost
                        key={index}
                        image="/img/articles/recent.svg"
                        text={article.title}
                        link={`/articulos/${article.categories[0]}/${article.id}`}
                      />
                    ))}
                  </CardPosts>
                </div>
              </div>
            </div>
          </div>
        </MobileView>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  articles: state.articlesReducer.articles.list,
});

const mapDispatchToProps = (dispatch) => ({
  getArticlesByPage: (params) => dispatch(getArticlesByPage(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ArticleCategory));
